import React from 'react';

const DashboardFooter = () => {
  return (
    <footer>
      <div className="max-w-screen-lg xl:max-w-screen-xl mx-auto px-4 sm:px-6 md:px-8 text-gray-500 pt-3">
        <div className="pt-2 flex items-center justify-center">
          <p className="text-sm font-body">Dashboard footer</p>
        </div>
      </div>
    </footer>
  );
};

export default DashboardFooter;
